__turbopack_context__.v({
  "content": "style-module-scss-module__hRK_BG__content",
  "divider": "style-module-scss-module__hRK_BG__divider",
  "item": "style-module-scss-module__hRK_BG__item",
  "lastItem": "style-module-scss-module__hRK_BG__lastItem",
  "text": "style-module-scss-module__hRK_BG__text",
  "title": "style-module-scss-module__hRK_BG__title",
  "withTopLine": "style-module-scss-module__hRK_BG__withTopLine",
  "wrapper": "style-module-scss-module__hRK_BG__wrapper",
});
